'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGES = exports.MESSAGES = ['messages'];
var START_TIMESTAMP = exports.START_TIMESTAMP = ['startTimestamp'];
var END_TIMESTAMP = exports.END_TIMESTAMP = ['endTimestamp'];
var VISITOR_LAST_READ_AT_TIMESTAMP = exports.VISITOR_LAST_READ_AT_TIMESTAMP = ['visitorLastReadAtTimestamp'];
var NUM_SOFT_DELETED_MESSAGES = exports.NUM_SOFT_DELETED_MESSAGES = ['numSoftDeletedMessages'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/constants/keyPaths.js
// module id = 114
// module chunks = 2 3